import api from './ApiMiddleware';

const getUserGroups = () => {
  return api.get(`/api/x2/usergroups`);
};

const createUserGroup = (customerId, userGroupName) => {
  return api.post('/api/x2/usergroups', {
    customerId,
    userGroupName,
  });
};

const updateUserGroup = (userGroupId, userGroupName) => {
  return api.put(`/api/x2/usergroups`, { userGroupId, userGroupName });
};

const deleteUserGroup = (groupId) => {
  return api.delete(`/api/x2/usergroups/${groupId}`);
};

const addMemberToUserGroup = (userGroupId, userId) => {
  return api.post('/api/x2/usergroups/member', {
    userGroupId,
    userId,
  });
};

const removeMemberFromUserGroup = (userGroupId, userId) => {
  return api.delete(`/api/x2/usergroups/${userGroupId}/user/${userId}`);
};

const UserGroupService = {
  getUserGroups,
  createUserGroup,
  updateUserGroup,
  deleteUserGroup,
  addMemberToUserGroup,
  removeMemberFromUserGroup,
};

export default UserGroupService;
